import { Brand } from "@/types/brand";
import { ProductsServicesForm } from "@/components/forms/ProductsServicesForm";



interface ProductsServicesStepProps {
  data: Brand;
  onNext: (data: Partial<Brand>) => void;
  onBack: () => void;
}

export function ProductsServicesStep({
  data,
  onNext,
  onBack,
}: ProductsServicesStepProps) {
  return (
    <ProductsServicesForm
      data={data}
      onSubmit={onNext}
      mode="onboarding"
      onBack={onBack}
    />
  );
}
